module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fc-Gc-Hc-Ic-Ja.b7c36090.png";